import { useCounselorsQuery } from "@/common/hooks/useCounselorsQuery";
import { formatCounselorLabel } from "@/common/utils/formatCounselorLabel";

export function useCounselors() {
  const { data, isLoading } = useCounselorsQuery((counselors) => {
    const active = counselors.filter((c) => c.isActive);

    return {
      all: counselors,
      counselors: active,
      counselorOptions: active.map((c) => ({
        id: c.counselorId,
        label: formatCounselorLabel(c),
        displayValue: c.userCode,
      })),
    };
  });

  const counselors = data?.counselors ?? [];

  // Looks among inactive counselors too: a selected or stored counselor may no longer be active, and only
  // the options are limited to active ones. "No counselor picked" resolves to no code.
  const userCodeOf = (counselorId: string | null): string | undefined =>
    counselorId === null ? undefined : data?.all.find((c) => c.counselorId === counselorId)?.userCode;

  return {
    counselors,
    counselorOptions: data?.counselorOptions ?? [],
    userCodeOf,
    isLoading,
  };
}
